import { CartItem } from '@/types/common-types'
import QuoteUpdatedFirst from 'components/Toasts/QuoteUpdatedFirst'
import toast from 'react-hot-toast'
import AnimatedCheckmark from '../components/AnimatedCheckmark'

export default function displayQuoteUpdatedToast(cart: CartItem[]): void {
	if (cart.length === 0 && localStorage.getItem('firstQuoteUpdated') === null) {
		toast.custom((t) => <QuoteUpdatedFirst t={t} />, {
			position: 'top-center',
			duration: 5000
		})
		localStorage.setItem('firstQuoteUpdated', 'true')
	} else {
		toast.success('Quote updated.', {
			position: 'top-center',
			icon: <AnimatedCheckmark size="ss" />
		})
	}
}
